export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_START = 'AUTH_START';
export const AUTH_END = 'AUTH_END';
export const CLEAN_UP = 'CLEAN_UP';
export const VERIFY_START = 'VERIFY_START';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const VERIFY_FAIL = 'VERIFY_FAIL';

export const RECOVERY_START = 'RECOVERY_START';
export const RECOVERY_SUCCESS = 'RECOVERY_SUCCESS';
export const RECOVERY_FAIL = 'RECOVERY_FAIL';

export const PROFILE_EDIT_START = 'PROFILE_EDIT_START';
export const PROFILE_EDIT_SUCCESS = 'PROFILE_EDIT_SUCCESS';
export const PROFILE_EDIT_FAIL = 'PROFILE_EDIT_FAIL';

export const DELETE_USER_START = 'DELETE_USER_START';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';

export const ADD_TODO_START = 'ADD_TODO_START';
export const ADD_TODO_FAIL = 'ADD_TODO_FAIL';
export const ADD_TODO_SUCCESS = 'ADD_TODO_SUCCESS';

export const DELETE_TODO_START = 'DELETE_TODO_START';
export const DELETE_TODO_FAIL = 'DELETE_TODO_FAIL';
export const DELETE_TODO_SUCCESS = 'DELETE_TODO_SUCCESS';

export const EDIT_TODO_START = 'EDIT_TODO_START';
export const EDIT_TODO_FAIL = 'EDIT_TODO_FAIL';
export const EDIT_TODO_SUCCESS = 'EDIT_TODO_SUCCESS';
